// extracted by mini-css-extract-plugin
export var cardHeader = "_s3-0";
export var reorderHandle = "_s3-3";
export var titleArea = "_s3-1";
export var titleAreaWithHandle = "_s3-2";